import { MenuItem, TextField } from "@mui/material";
import { sortBy } from "lodash-es";
import { type FC, useCallback } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { PollPresets } from "../hooks/use-poll-default-values";
import type { PollWrapperSchema } from "../types";

export const PollFormSelectQuestionType: FC<{ presets: PollPresets }> = ({ presets }) => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<PollWrapperSchema>();

  const setAnswerType = useCallback(
    (value: string) => {
      if (value === "custom") {
        setValue("poll.question", "");
        setValue("question_type", { type: "custom" });
        setValue("poll.answer_type", {
          type: "custom",
          button_type: "primary_button",
          alignment: "vertical",
        });
        setValue("poll.options", []);
        setValue("poll.helper_text", null);
        return;
      }

      const preset = presets.questions.find((p) => p.id === value);
      if (!preset) return;

      setValue("question_type", { type: "preset", variation: preset.id });
      setValue("poll.question", preset.question);

      setValue("poll.answer_type", { type: "preset", variation: preset.answer_type_id });
      setValue("poll.options", preset.answer_type_options);
      setValue("poll.helper_text", preset.helper_text || null);
    },
    [setValue, presets],
  );

  return (
    <Controller
      name="question_type"
      control={control}
      render={({ field }) => (
        <TextField
          select
          label={t("Question Type")}
          value={field.value.type === "custom" ? "custom" : field.value.variation}
          fullWidth
          onChange={(e) => {
            field.onChange(e);
            setAnswerType(e.target.value);
          }}
        >
          <MenuItem value="custom">{t("Write your own question")}</MenuItem>
          {sortBy(presets.questions, "order").map((preset) => (
            <MenuItem key={preset.id} value={preset.id}>
              {preset.question}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};
